import PartnerRewardsFields from './PartnerRewardsFields';

export default PartnerRewardsFields;
